module.exports = __webpack_public_path__ + "static/img/荣誉_07@2x.9f6ffbd6.png";